// Author Lin
// Date 2024-06-18 08:56:52

class SithMesInventoryDeliveryMaterial {
    constructor({
                    id = null,
                    deliveryTaskId = '',
                    deliveryDescription = '',
                    materialCode = '',
                    materialDesc = '',
                    materialState = '',
                    unit = '',
                    isCounted = '',
                    quantity = '',
                    packagedQuantity = '',
                    packagePlanTime = '',
                    packageActualTime = '',
                    packageLocId = '',
                    binCode = '',
                    deliveryCode = '',
                    deliveryLocId = '',
                    cid = '',
                    identifier = '',
                    productionOrder = '',
                    materialCountWorker = '',
                    materialCountAssignedWorkerLoginName = '',
                    attachment = '',
                    dnNumber = '',
                    dnItem = '',
                    wbsNumber = '',
                    salesOrder = '',
                    grossWeight = '',
                    remark = '',
                    countTime = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.deliveryTaskId = deliveryTaskId;
        this.deliveryDescription = deliveryDescription;
        this.materialCode = materialCode;
        this.materialDesc = materialDesc;
        this.materialState = materialState;
        this.unit = unit;
        this.isCounted = isCounted;
        this.quantity = quantity;
        this.packagedQuantity = packagedQuantity;
        this.packagePlanTime = packagePlanTime;
        this.packageActualTime = packageActualTime;
        this.packageLocId = packageLocId;
        this.binCode = binCode;
        this.deliveryCode = deliveryCode;
        this.deliveryLocId = deliveryLocId;
        this.cid = cid;
        this.identifier = identifier;
        this.productionOrder = productionOrder;
        this.materialCountWorker = materialCountWorker;
        this.materialCountAssignedWorkerLoginName = materialCountAssignedWorkerLoginName;
        this.attachment = attachment;
        this.dnNumber = dnNumber;
        this.dnItem = dnItem;
        this.wbsNumber = wbsNumber;
        this.salesOrder = salesOrder;
        this.grossWeight = grossWeight;
        this.remark = remark;
        this.countTime = countTime;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryDeliveryMaterial();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryNumber',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.deliveryNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDescription',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.deliveryDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bulk',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.bulk',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDesc',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.materialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialState',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.materialState',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '待清点'},
                    {value: '2', text: '待包装'},
                    {value: '3', text: '已装箱'},
                    {value: '4', text: '已开箱检验'}
                ]
            }
        },
        {
            key: 'isCounted',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.isCounted',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packagedQuantity',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.packagedQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packagePlanTime',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.packagePlanTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageActualTime',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.packageActualTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'binCode',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.binCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryCode',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.deliveryCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cid',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.cid',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryLoc',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.deliveryLoc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageLoc',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.packageLoc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'productionOrder',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.productionOrder',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCountWorkerName',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.materialCountWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'countTime',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.countTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCountAssignedWorkerName',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.materialCountAssignedWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnNumber',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.dnNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnItem',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.dnItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.wbsNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.salesOrder',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'grossWeight',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.grossWeight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    deliveryTaskIdFilter: '',
    projectCodeFilter: '',
    deliveryDescriptionFilter: '',
    materialCodeFilter: '',
    bulkFilter: '',
    materialDescFilter: '',
    materialStateFilter: '',
    isCountedFilter: '',
    packagePlanTimeRteFilter: '',
    packagePlanTimeLteFilter: '',
    packageActualTimeRteFilter: '',
    packageActualTimeLteFilter: '',
    packageLocIdFilter: '',
    identifierFilter: '',
    binCodeFilter: '',
    deliveryCodeFilter: '',
    productionOrderFilter: '',
    materialCountWorkerFilter: '',
    materialCountWorkerNameFilter: '',
    countTimeRteFilter: '',
    countTimeLteFilter: '',
    materialCountAssignedWorkerLoginNameFilter: '',
    dnNumberFilter: '',
    dnItemFilter: '',
    wbsNumberFilter: '',
    salesOrderFilter: '',
    grossWeightFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'deliveryTaskIdFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.deliveryTaskId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryTask'
            , correspondingField: 'id'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDescriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.deliveryDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialStateFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.materialState',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '待清点'},
                {value: '2', text: '待包装'},
                {value: '3', text: '已装箱'},
                {value: '4', text: '已开箱检验'}
            ]
        }
    },
    {
        key: 'isCountedFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.isCounted',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packagePlanTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.packagePlanTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packagePlanTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.packagePlanTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageActualTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.packageActualTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageActualTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.packageActualTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageLocIdFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.packageLocId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'binCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.binCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.deliveryCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionOrderFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.productionOrder',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.materialCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'countTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.countTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'countTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.countTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountAssignedWorkerLoginNameFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.materialCountAssignedWorkerLoginName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'dnNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.dnNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dnItemFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.dnItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.wbsNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.salesOrder',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const partsFilterConfigs = [
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const dn400FilterConfigs = [
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const inspectionFilterConfigs = [
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const orderFilterConfigs = [
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'deliveryTaskId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.deliveryTaskId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryTask'
            , correspondingField: 'id'
        }
    },
    {
        key: 'deliveryDescription',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.deliveryDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDesc',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.materialDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.unit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packagePlanTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.packagePlanTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageActualTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.packageActualTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageLocId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.packageLocId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.binCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryLocId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.deliveryLocId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'cid',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.cid',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionOrder',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.productionOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorker',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.materialCountWorker',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'materialCountAssignedWorkerLoginName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.materialCountAssignedWorkerLoginName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'dnNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.dnNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dnItem',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.dnItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.salesOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grossWeight',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.grossWeight',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryMaterial.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    SithMesInventoryDeliveryMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, partsFilterConfigs, dn400FilterConfigs, inspectionFilterConfigs, orderFilterConfigs


}
